import clsx from 'clsx'

import type { DeliveryPointItem } from '@/entities/order/types/delivery'

import { DeliveryPointInfo } from '../../api/pvz-api'
import { ShopCard } from '../shops-card/shop-card'

import cls from './shop-detail-card.module.scss'

type ShopDetailCardProps = {
	point: DeliveryPointItem
	onClose?: () => void
	className?: string
	deliveryInfo: DeliveryPointInfo
}

export const ShopDetailCard = (props: ShopDetailCardProps) => {
	const { point, deliveryInfo, onClose, className } = props

	return (
		<div className={clsx(cls.root, className)}>
			<button className={cls.backButton} onClick={onClose}>
				Вернуться назад
			</button>
			<ShopCard
				metro={point.METRO_LINE}
				address={point.ADDRESS}
				postamat={point.POSTAMAT}
				storagePeriod={point.STORAGE_PERIOD}
				workShedule={point.WORK_SHEDULE}
				partner={point.DELIVERY_PVZ_PARTNER}
				description={point.DESCRIPTION}
				deliveryPrice={deliveryInfo?.DELIVERY_PRICE}
				deliveryDate={deliveryInfo?.DELIVERY_DATE}
			/>
		</div>
	)
}
